module.exports = __webpack_public_path__ + "static/images/bni.1DiZ7jh.svg";